// Enumerations
import { ErrorViewTrackingEnumeration } from '../../enumerations/error-view-tracking.enumeration';
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Utilities
import {
  isContractError,
  isKycError,
  isPaymentError,
  isProofIncomeError,
  isUploadIdError,
} from '../../utils/error.utils';

const customerCantContinueAndHasToReturnAmazon = (error: AppErrorEnumeration): boolean =>
  [
    AppErrorEnumeration.AUTH_DATA_CLEAN_FAILED,
    AppErrorEnumeration.CHECKOUT_NO_INFO,
    AppErrorEnumeration.AUTH_WEALTH_REFRESH_TOKEN_FAILED,
    AppErrorEnumeration.NO_AUTH_DATA_FROM_QUERY_TOKEN,
    AppErrorEnumeration.NO_LOGGED_OR_QUERY_TOKEN,
    AppErrorEnumeration.NO_REDIRECTED_FORCED_AND_STILL_STAY,
    AppErrorEnumeration.PRECONTRACT_GIL_RISK_ERROR,
    AppErrorEnumeration.OPERATIVE_TOO_MANY_REQUESTS,
    AppErrorEnumeration.REFRESH_TOKEN_REMOVED,
    AppErrorEnumeration.STATE_FAILED,
    AppErrorEnumeration.TOKEN_REMOVED,
    AppErrorEnumeration.UNKNOWN_ERROR,
    AppErrorEnumeration.PAYMENT_MAX_ATTEMPTS,
  ].includes(error);

const isUploadIdBizumTimerExpiredError = (error: AppErrorEnumeration): boolean =>
  error === AppErrorEnumeration.UPLOAD_ID_BIZUM_TIMER_EXPIRED;

const getTrackingViewFromError = (error: AppErrorEnumeration): string => {
  let view;
  switch (true) {
    case isContractError(error):
      view = ErrorViewTrackingEnumeration.SIGNATURE;
      break;
    case isKycError(error):
      view = ErrorViewTrackingEnumeration.VERIFY_IDENTITY;
      break;
    case isProofIncomeError(error):
      view = ErrorViewTrackingEnumeration.VERIFY_INCOME;
      break;
    case isPaymentError(error):
      view = ErrorViewTrackingEnumeration.PAYMENT;
      break;
    case isUploadIdError(error):
      view = ErrorViewTrackingEnumeration.VALIDATE_THE_DOCUMENTS;
      break;
    default:
      view = ErrorViewTrackingEnumeration.GENERIC_ERROR;
  }
  return view;
};

export {
  customerCantContinueAndHasToReturnAmazon,
  getTrackingViewFromError,
  isUploadIdBizumTimerExpiredError,
};
